'use client';

export { default } from "./useLazyRipple.mjs";